import { getRecentHistoryList } from 'dibs-recent-history/exports/getRecentHistory.ts';
import { type UserRecentHistoryItemType } from 'dibs-recent-history/exports/types.ts';

const MIN_RECENTLY_VIEWED_TOP_ITEMS = 4;

export const getRecentlyViewedDisplayInfo = ({
    isClient,
    itemId,
    recentHistoryItems,
}: {
    isClient: boolean;
    itemId?: string;
    recentHistoryItems: UserRecentHistoryItemType[];
}): { showRecentlyViewed: boolean; numRecentlyViewedItems: number } => {
    const recentlyViewedItems =
        getRecentHistoryList({ itemId, recentHistoryItems, isClient }) || [];
    const numRecentlyViewedItems = recentlyViewedItems.length;

    const showRecentlyViewed = isClient && numRecentlyViewedItems >= MIN_RECENTLY_VIEWED_TOP_ITEMS;

    return {
        showRecentlyViewed,
        numRecentlyViewedItems,
    };
};
